import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';
import { TableDataJSON } from '../../../src/types/table-json';

export const rangeDescription: CalculatorDescription = {
  id: CalculatorId.RANGE,
  title: 'Range calculator',
  metaTitle: 'Range Calculator - Find Data Spread and Dispersion',
  description: 'Calculate the range of your dataset to measure the spread between the minimum and maximum values.',
  metaDescription: 'Free online range calculator. Find the spread of your data with our easy-to-use statistical tool. Analyze data dispersion instantly.',
  howTo: {
    title: 'How to calculate range',
    steps: [
      'Enter your numeric data directly into the data table or upload a CSV file',
      'Use the "Select Data Column" control to choose which column of data to analyze',
      'The calculator will automatically find the minimum and maximum values',
      'The range is calculated as maximum - minimum',
      'View the visualization to see the data spread and distribution'
    ],
    graphic: {
      description: 'Visual representation of range calculation'
    }
  },
  examples: [
    {
      title: 'Finding the range of temperature data',
      description: 'Analyzing temperature variation over a month',
      dataDescription: 'Daily high temperatures (°F) for a 30-day period',
      insights: [
        'The range is 32°F (92°F - 60°F)',
        'Large range indicates significant temperature fluctuation',
        'Range alone doesn\'t show distribution within the extremes',
        'Compare with standard deviation for better dispersion analysis'
      ],
      data: TableDataJSON.from({
        columns: [
          { 
            id: 'temperatures',
            name: 'Temperature (°F)', 
            values: ['72', '75', '78', '80', '82', '85', '88', '90', '92', '88', '85', '82', '78', '75', '72', '68', '65', '62', '60', '63', '67', '70', '73', '76', '79', '82', '85', '88', '85', '82'] 
          }
        ]
      })
    }
  ],
  relatedCalculators: [
    CalculatorId.STANDARD_DEVIATION,
    CalculatorId.VARIANCE,
    CalculatorId.QUARTILE
  ]
}; 